module.exports = {
      id: "logout-usage",
      viewBox: "0 0 75 28",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#logout",
      toString: function () {
        return this.url;
      }
    }